if (!customElements.get("info-slider")) {
    customElements.define(
      "info-slider",
      class InfoSlider extends HTMLElement {
        constructor() {
          super();
        }
  
        connectedCallback() {
            this.id = this.id;
            this.slider = this.querySelector('.info-slider__slider');
            this.swiper = null;
            this.slidesPerRow = this.getAttribute('data-slide-per-row');
            this.enabledReadMore = this.getAttribute('data-read-more');
            this.openPopupBtn = this.querySelector('.js-info-slider__open-popup');
            this.popup = this.querySelector('.js-info-slider__popup');
            this.popupOverlay = this.querySelector('.js-info-slider__popup-overlay');
            this.closePopupBtn = this.querySelector('.js-info-slider__popup-close');

            this.openPopupBtn?.addEventListener('click', this.handleOpenPopup);
            this.closePopupBtn?.addEventListener('click', this.handleClosePopup);
            this.popupOverlay?.addEventListener('click', this.handleClosePopup);


            if(this.slider){
                this.innitSlider();
            }
            if(this.enabledReadMore == 'true'){
                this.handleReadMoreButtons();
            }
        }
  
        disconnectedCallback() {

        }

        handleOpenPopup = ()=> {
          this.popup?.classList.add('is-open');
        }

        handleClosePopup = ()=> {
          this.popup?.classList.remove('is-open');
        }
  
        innitSlider(){
             this.swiper = new Swiper(this.slider,{
                slidesPerView: 1.3,
                spaceBetween: 16,
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
                speed: 500,
                loop: false,
                navigation: {
                    nextEl: `#${this.id} .swiper-button-next`,
                    prevEl: `#${this.id} .swiper-button-prev`
                },
                pagination: {
                    el: `#${this.id} .swiper-pagination`
                },
                breakpoints: {
                        768: {
                            slidesPerView: 2.3,
                            slidesOffsetBefore: 48,
                            slidesOffsetAfter: 48
                        },
                        900: {
                            slidesPerView: 3.3,
                            slidesOffsetBefore: 48,
                            slidesOffsetAfter: 48
                        },
                        1060: {
                            slidesPerView: +this.slidesPerRow,
                            spaceBetween: 24,
                            slidesOffsetBefore: 48,
                            slidesOffsetAfter: 48
                        }
                }
            });
        }

        handleReadMoreButtons() {
            const items = this.querySelectorAll('.info-slider__item-text-wrapper');
          
            items.forEach(wrapper => {
              const textEl = wrapper.querySelector('.info-slider__item-text');
              const btn = wrapper.querySelector('.info-slider__read-more-btn');
          
              if (!textEl || !btn) return;
          
              const isClamped = textEl.scrollHeight > textEl.offsetHeight + 1;
          
              if (!isClamped) {
                btn.style.display = 'none';
                return;
              }
          
              btn.addEventListener('click', () => {
                const isExpanded = textEl.classList.toggle('is-expanded');
                btn.textContent = isExpanded ? 'Weniger anzeigen' : 'Mehr lesen';
              });
            });
        }
        
      }
    );
  }
  